<ng-container *ngTemplateOutlet="logoWebserverEnabled() ? newLogoTemplate : oldLogoTemplate"/>

<ng-template #newLogoTemplate>
  <ng-container *ngTemplateOutlet="showLogo() ? webserverLogoTemplate : avatarTemplate"/>
</ng-template>

<ng-template #oldLogoTemplate>
  <ng-container *ngTemplateOutlet="showOldLogo() ? stringLogoTemplate : avatarTemplate"/>
</ng-template>

<ng-template #stringLogoTemplate>
  <img class="td-wb-symbol-logo__logo td-wb-symbol-logo__logo--show"
       [style.--td-wb-logo-size]="getSize()"
       [alt]="symbol()"
       [src]="getSVGImageUrlFromString()">
</ng-template>

<ng-template #webserverLogoTemplate>
  @if (!hasImageLoaded()) {
    <!-- Placeholder while image is loading -->
    @if (customImageLoadingPlaceholder()) {
      <ng-content/>
    } @else {
      <td-wb-avatar [initials]="getInitials()"
                    avatarType="logo"
                    [size]="size()"/>
    }
  }
  <img [class.td-wb-symbol-logo__logo--hide]="!hasImageLoaded()"
       [class.td-wb-symbol-logo__logo--show]="hasImageLoaded()"
       class="td-wb-symbol-logo__logo"
       [style.--td-wb-logo-size]="getSize()"
       [alt]="symbol()"
       [src]="getSVGImageUrl()"
       loading="lazy"
       (load)="onImageLoad()"
       (error)="onImageLoadError()">
</ng-template>

<ng-template #avatarTemplate>
  <td-wb-avatar [initials]="getInitials()"
                avatarType="logo"
                [size]="size()"/>
</ng-template>
